module.exports = __webpack_public_path__ + "media/images/win@2x-71b32eb71d41a4ebde599451719a59d4.png";